var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pagination.pageCount > _vm.pagination.currentPage)?_c('div',{directives:[{name:"animation",rawName:"v-animation:bottom.delay",arg:"bottom",modifiers:{"delay":true}}],staticClass:"t-load-more"},[_c('div',{staticClass:"t-btn _border-green _big",class:{_disabled: _vm.disabledBtn},on:{"click":function($event){return _vm.clickLoadMore(_vm.pagination.currentPage)}}},[_vm._v("\n        "+_vm._s(_vm.btn)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/load-more/load-more.vue?vue&type=template&id=4c286c80&
// module id = 994
// module chunks = 0